import React, { useState } from "react";

const TaxProviders = () => {
  const [providers, setProviders] = useState([
    {
      id: 1,
      friendlyName: "Avalara tax provider",
      systemName: "Tax.Avalara",
      isPrimary: false,
    },
    {
      id: 2,
      friendlyName: "Manual (Fixed or By Country/State/Zip)",
      systemName: "Tax.FixedOrByCountryStateZip",
      isPrimary: true,
    },
  ]);

  const handlePrimary = (id) => {
    setProviders((prev) =>
      prev.map((p) => ({ ...p, isPrimary: p.id === id }))
    );
  };

  return (
    <div className="p-4 md:p-8 bg-gray-50 min-h-screen">
      <div className="max-w-5xl mx-auto bg-white shadow rounded-lg p-6">
        {/* Header */}
        <h1 className="text-2xl font-semibold mb-2">Tax providers</h1>
        <p className="text-sm text-gray-600 mb-4">
          Learn more about{" "}
          <a href="#" className="text-blue-600 underline">
            tax providers
          </a>
          . You can download more plugins in our{" "}
          <a href="#" className="text-blue-600 underline">
            marketplace
          </a>
          .
        </p>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-200 text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="text-left px-4 py-2 border-b border-gray-200">
                  Friendly name
                </th>
                <th className="text-left px-4 py-2 border-b border-gray-200">
                  System name
                </th>
                <th className="text-left px-4 py-2 border-b border-gray-200">
                  Is primary provider
                </th>
                <th className="text-left px-4 py-2 border-b border-gray-200">
                  Mark as primary provider
                </th>
                <th className="text-left px-4 py-2 border-b border-gray-200">
                  Configure
                </th>
              </tr>
            </thead>
            <tbody>
              {providers.map((provider, idx) => (
                <tr
                  key={provider.id}
                  className={idx % 2 === 0 ? "bg-white" : "bg-gray-50"}
                >
                  <td className="px-4 py-2 border-b border-gray-200">
                    {provider.friendlyName}
                  </td>
                  <td className="px-4 py-2 border-b border-gray-200">
                    {provider.systemName}
                  </td>
                  <td className="px-4 py-2 border-b border-gray-200 text-center">
                    {provider.isPrimary ? (
                      <span className="text-green-600 text-lg font-bold">✔</span>
                    ) : (
                      <span className="text-red-600 text-lg font-bold">✖</span>
                    )}
                  </td>
                  <td className="px-4 py-2 border-b border-gray-200">
                    <button
                      onClick={() => handlePrimary(provider.id)}
                      className="bg-green-600 text-white text-sm px-3 py-1 rounded hover:bg-green-700 transition"
                    >
                      Mark as primary provider
                    </button>
                  </td>
                  <td className="px-4 py-2 border-b border-gray-200">
                    <button className="flex items-center gap-1 bg-gray-100 border border-gray-300 px-3 py-1 rounded hover:bg-gray-200 transition text-sm">
                      ⚙ Configure
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Footer Controls */}
        <div className="flex flex-col sm:flex-row justify-between items-center mt-4 text-sm text-gray-600">
          <div className="flex items-center gap-2 mt-2 sm:mt-0">
            <span>Show</span>
            <select className="border border-gray-300 rounded px-2 py-1">
              <option>15</option>
              <option>30</option>
              <option>50</option>
            </select>
            <span>items</span>
          </div>

          <div className="flex items-center gap-2 mt-3 sm:mt-0">
            <button className="border border-gray-300 px-3 py-1 rounded hover:bg-gray-100 transition">
              Previous
            </button>
            <button className="bg-blue-600 text-white px-3 py-1 rounded">
              1
            </button>
            <button className="border border-gray-300 px-3 py-1 rounded hover:bg-gray-100 transition">
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaxProviders;
